import {createCredentials, getCredentials, updateCredentials} from "../Repository";
import {defaultCredentialData} from "../constants";
import {initialState} from './state.js';
import { v4 as uuid4 } from 'uuid';

import {
    FETCH_CREDENTIALS,
    ADD_CREDENTIAL,
    RESET_STATE, EDIT_CREDENTIAL, SAVE_CREDENTIAL, UPDATE_CREDENTIAL
} from './types';

export default {

    [FETCH_CREDENTIALS] ({state}) {
        state.processing = true;

        return getCredentials()
            .then(({data}) => state.credentialTypes = data)
            .finally(() => state.processing = false);
    },

    [EDIT_CREDENTIAL] ({state, getters}, data = {}) {
        const credentialType = getters.credentialType;
        let credential = {...defaultCredentialData, ...data};

        if (!credentialType) {
            throw new Error('Credential type not selected, pleas chose credential type.');
        }

        credentialType.accessProperties.forEach(o => {
            credential.data[o.name] = credential.data[o.name] || null;
        });

        state.credential = credential;
        state.showForm = true;
    },

    [SAVE_CREDENTIAL] ({state, commit, dispatch}, credential) {
        const data = {...credential};
        const isNew = data.uuid === null;

        data.uuid = data.uuid || uuid4();
        state.processing = true;

        return (isNew ? createCredentials(data) : updateCredentials(data.uuid, data)).then(() => {
            if (isNew) {
                commit(ADD_CREDENTIAL, data);
                dispatch(EDIT_CREDENTIAL, data);
            } else {
                commit(UPDATE_CREDENTIAL, [data.uuid, data]);
            }
        }).finally(() => state.processing = false);
    },

    [RESET_STATE] ({state}) {
        Object.assign(state, initialState());
    }
};
